import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchReferralDetail = gql`
  query FetchReferralDetail {
    referralDetail {
      __typename
      ... on ReferralCardDetail {
        logoImage
        id
        cardTitle
        subTitle
        partnerOfferCardDetailTerms {
          heading
          iconUrl
          icon
          id
          subHeading
        }
        legalLink {
          text
          url
        }
        abbreviatedTerms {
          copy
          title
        }
        displayUrl
        offerCode
        offerUrl
        cta {
          action
          backgroundColour
          id
          title
          url
        }
        shareLinkText
      }

      ... on ReferralDetailExpired {
        title
        message
      }
      ... on ReferralDetailError {
        ...error
      }
    }
  }
  ${error}
`;

export default FetchReferralDetail;
